// eslint-disable-next-line no-underscore-dangle
import deepMap from '../../../object/deepMap';

const isMoment = obj => obj?._isAMomentObject;

const mapper = value => {
    if (isMoment(value)) {
        return {
            _value: value.toISOString(),
            _type: 'moment'
        };
    }

    if (Array.isArray(value)) {
        return {
            _value: value.map(mapper),
            _type: 'array'
        };
    }

    if (typeof value === 'string') {
        return value;
    }

    if (value instanceof Date) {
        try {
            return {
                _value: value.toISOString(),
                _type: 'date'
            };
        } catch {
            return;
        }
    }

    if (value instanceof Set) {
        return {
            _value: [...value].map(mapper),
            _type: 'set'
        };
    }

    if (value === undefined) {
        return value;
    }

    if (value === null) {
        return {
            _type: 'null'
        };
    }

    return { _value: String(value), _type: typeof value };
};

const serializeToQueryString = object => deepMap(object, mapper, obj => isMoment(obj) || obj instanceof Date || obj instanceof Set || Array.isArray(obj));

export default serializeToQueryString;
